var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#00615A;}\n"),React.createElement("circle",{"className":"st0","cx":"3","cy":"16.9","r":"2","key":1}),React.createElement("path",{"className":"st0","d":"M1,0.9h4v12H1V0.9z","key":2})]);
}

Attention.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 6 20","style":{"enableBackground":"new 0 0 6 20"},"xmlSpace":"preserve"};

module.exports = Attention;

Attention.default = Attention;
